import { createReducer, on } from '@ngrx/store';

import { IUnitCodesState, initialUnitCodesState } from './unitCodes.state';
import { UnitCodesLoaded } from './unitCodes.actions';


export const initialState: IUnitCodesState = {
  unitCodes: []
};

const setUnitCodes = (state: IUnitCodesState, { unitCodes }: { unitCodes: any[] }) => ({
  ...state,
  unitCodes
});


const _unitCodesReducer = createReducer<IUnitCodesState>(
  initialUnitCodesState,
  on(UnitCodesLoaded, setUnitCodes)
);

export function unitCodesReducer(state: IUnitCodesState, action): IUnitCodesState {
  return _unitCodesReducer(state, action);
}
